export const MSAL_CONFIG = {
    auth: {
        clientId: '8ce1a425-35fc-4d1e-9bf8-4250886fd5ef',
        redirectUri: `https://${location.hostname}/auth/microsoft/callback`,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
}

export const TEAMS_ICON = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><circle cx="256" cy="256" r="256" style="" fill="#827ddc" data-original="#827ddc" class=""></circle><path d="m353.58 190.934-29.529-29.529c-5.095-5.094-12.013-8.366-19.691-8.752l-37.748-37.748-173.486 30.438v217.313L242.09 511.62c4.606.247 9.242.38 13.91.38 130.026 0 237.401-96.941 253.816-222.489L401.89 181.584l-.004-.004c-5.372-5.371-12.793-8.693-20.99-8.693-12.264 0-22.789 7.438-27.316 18.047z" style="" fill="#6e64c3" data-original="#6e64c3"></path><path d="m93.126 362.657 173.486 30.437V114.906L93.126 145.343zM279.106 347a37.61 37.61 0 0 0 23.722 8.385c20.864 0 37.778-16.914 37.778-37.778v-90.832h-61.501L279.106 347zM302.828 212.646c16.577 0 30.016-13.438 30.016-30.016 0-16.577-13.438-30.016-30.016-30.016-9.651 0-18.232 4.56-23.722 11.637v36.758c5.491 7.078 14.071 11.637 23.722 11.637zM418.262 246.237H353.03v80.234c6.857 8.07 17.076 13.188 28.482 13.188a37.36 37.36 0 0 0 37.359-37.768l-.609-55.654z" style="" fill="#302c89" data-original="#302c89" class=""></path><circle cx="380.9" cy="202.57" r="29.688" style="" fill="#302c89" data-original="#302c89" class=""></circle><path d="M214.083 222.896h-25.88v75.613h-15.619v-75.613h-25.88v-15.533h67.378v15.533h.001z" style="" fill="#ffffff" data-original="#ffffff"></path></g></svg>`


export const EVENT_TYPE_MAP = {
"#microsoft.graph.membersAddedEventMessageDetail":"User Added"
}

export const USER_STATUS_MAP = {
    "Available": "online",
    "Offline": "offline",
    "Away": "away",
    "Busy": "busy",
    "Do Not Disturb": "dnd",
    "Be Right Back": "brb",
    "unknown": "Unknown",
}
